import React, { useState, useEffect } from "react";
import { IoMdSearch } from "react-icons/io";
import Modal from "react-modal";
import Plan from "./Plan";
import Package from "../assets/images/Home/Package.svg";
import { GoDownload } from "react-icons/go";
import LoadingSpinner from "../components/LoadingSpinner";
import Pagination from "../components/Pagination";
import Plus from "../assets/images/Home/Plus.svg";
import { toast } from "react-toastify";
import { ImCross } from "react-icons/im"; // Import the cross icon
import Premium from "../assets/images/Home/Premium.svg";
import Standard from "../assets/images/Home/Standard.svg";
import Lifetime from "../assets/images/New_Jul_2025/Life.svg";
import iota from "../assets/images/New_Jul_2025/iota.svg";

const EsimStore = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const role = localStorage.getItem("role");
  const [error, setError] = useState(null);

  const itemsPerPage = 10;
  const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const [packageType, setPackageType] = useState(null);
  const [hovered, setHovered] = useState("");
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 }); // To store cursor position
  const [description, setDescription] = useState(""); // New state for description
  const LIFETIME_PLAN_IDS = ["3129"]; // you can expand this later

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "Payaspergo") {
      setSelectedPackageType("Standard");
      setPackageType("");
    } else {
      setSelectedPackageType("Premium");
      setPackageType("voicedata");
    }
  }, []);

  const premiumPackageTypes = ["voicedata", "data"];
  const standardPackageTypes = ["", "Daily"];

  useEffect(() => {
    const cached = sessionStorage.getItem("cachedPlans");
    if (cached) {
      setPlans(JSON.parse(cached));
      return;
    }

    const fetchPlans = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const partnerCode = localStorage.getItem("partnerCode");
        const response = await fetch(
          `${apiUrl}ESIM/Get_all_plans?flag=1&PartnerCode=${partnerCode}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data.isSuccess) {
          const sortedPlans = data.getallplan.sort((a, b) =>
            a.country.localeCompare(b.country)
          );
          // Immediately load first 10 plans for quick UI response
          setPlans(sortedPlans.slice(0, 10));

          // Cache entire dataset for later use
          sessionStorage.setItem("cachedPlans", JSON.stringify(sortedPlans));

          // Load full data in background
          setTimeout(() => {
            setPlans(sortedPlans);
          }, 0); // Set as soon as current render finishes
        }
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // reset to first page whenever search changes
  };

  const filteredPlans = plans.filter((plan) => {
      const isLifetimePlan = LIFETIME_PLAN_IDS.includes(String(plan.planid));
  // 1) Lifetime tab – show only lifetime plans
  if (selectedPackageType === "Lifetime") {
    // Option A: pure whitelist by ID
    return isLifetimePlan;
  }
      // 2) For Premium + Standard, **force hide** these lifetime plans
  if (isLifetimePlan) {
    return false;
  }

    const isPremiumPlan =
      plan.plan_type === "Premium_plan" &&
      plan.plan_Class === packageType &&
      plan.country.toLowerCase().includes(searchQuery.toLowerCase());

    const isStandardPlan =
      plan.plan_type === "Standard_plan" &&
      (packageType === ""
        ? plan.plan_datatype === ""
        : plan.plan_datatype === packageType) &&
      plan.country.toLowerCase().includes(searchQuery.toLowerCase());

    return isPremiumPlan || isStandardPlan;
  });

  const totalPages = Math.ceil(filteredPlans.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPlans = filteredPlans.slice(indexOfFirstItem, indexOfLastItem);

  const handleBuyClick = (plan) => {
    localStorage.setItem("planCode", plan.plancode);
    localStorage.setItem("plan_id", plan.planid);
    setSelectedPlan(plan);
    setModalIsOpen(true);
  };

  const closeModal = () => setModalIsOpen(false);
  const downloadCSV = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const partnerCode = localStorage.getItem("partnerCode");

      if (!token) {
        setError("No token found. Please log in.");
        return;
      }

      const response = await fetch(
        `${apiUrl}ESIM/Get_all_plans?flag=1&PartnerCode=${partnerCode}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      const data = await response.json();
      if (data.isSuccess) {
        let { getallplan } = data;
        getallplan = getallplan.sort((a, b) =>
          a.country.localeCompare(b.country)
        );

        const header =
          "Country,Data,Validity,Portal Price,plan_Class,plan_type,connectivity,plancode,countries_covered\n";
        const discount = parseFloat(localStorage.getItem("Discount")) || 20;

        const rows = getallplan
          .map((plan) => {
            const portalPrice = parseFloat(plan.sellingcost);
            const websitePrice = portalPrice * (1 - discount / 100);
            return `${plan.country},${
              plan.data === "" ? "Unlimited" : plan.data
            },${plan.validity},$${portalPrice.toFixed(2)},${plan.plan_Class},${plan.plan_type},${
              plan.connectivity
            },${plan.plancode},"${plan.countries_covered}"`;
          })
          .join("\n");

        const csvContent = header + rows;
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "plans.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Error downloading the file:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const currentPackageOptions =
  selectedPackageType === "Premium"
    ? premiumPackageTypes
    : selectedPackageType === "Standard"
    ? standardPackageTypes.map((type) =>
        type === "" || type === null ? "fixed" : type
      )
    : []; // Lifetime: no sub-tabs like Fixed/Daily


  const addToCart = (plan) => {
    const existing = JSON.parse(localStorage.getItem("cartPlans") || "[]");

    // Check if plan with same plancode already exists
    const alreadyExists = existing.some((p) => p.plancode === plan.plancode);
    if (alreadyExists) {
      toast.error("This plan is already in the cart.");
      return;
    }

    // Optional: limit total number of plans in cart
    if (existing.length >= 10) {
      toast.error("You can only add up to 10 plans to the cart.");
      return;
    }

    const updated = [...existing, { ...plan, quantity: plan.quantity || 1 }];
    localStorage.setItem("cartPlans", JSON.stringify(updated));
  };

  const handleHover = (e, type) => {
    setHovered(type);
    setCursorPosition({ x: e?.clientX || 0, y: e?.clientY || 0 }); // Update cursor position on hover

    if (type === "voicedata") {
      setDescription("High-speed plans with local number, calls and texts.");
    } else if (type === "data") {
      setDescription(
        "High-speed, low-latency plans with fixed or unlimited data."
      );
    } else if (type === "fixed") {
      setDescription("Fixed data plans with low latency and recharge option.");
    } else if (type === "Daily") {
      setDescription("Daily unlimited plans with speed cap after fair usage.");
    } else {
      setDescription(""); // Reset description for any other hover
    }
  };

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
      )}

     <div className="flex flex-col gap-4 w-full p-2">

  {/* Plan Selector Group: vertical for mobile, horizontal for large screens */}
  <div className="flex flex-col sm:flex-row justify-between gap-3 w-full">
  {/* LEFT: Selector boxes */}
  <div className="flex flex-row justify-start gap-3">
    {["Premium", "Standard", "Lifetime"].map((type) => {
      const role = localStorage.getItem("role");
      if (role === "Payaspergo" && type === "Premium") return null;

      return (
        <div
          key={type}
          onClick={() => {
            setSelectedPackageType(type);
            if (type === "Standard") setPackageType("");
            else if (type === "Premium") setPackageType("voicedata");
            else if (type === "Lifetime") setPackageType("lifetime");
          }}
          onMouseEnter={(e) => handleHover(e, type)}
          onMouseLeave={() => setHovered("")}
          className={`rounded-xl sm:rounded-3xl flex flex-row items-center justify-center px-4 py-2 border shadow-sm transition-all duration-150 cursor-pointer
            ${selectedPackageType === type
              ? "bg-white text-black font-bold border-[#83b1ab] shadow-lg"
              : "bg-[#f5f8fa] text-[#718EBF] border-transparent "
            }
          `}
          style={{ minWidth: '130px' }}
        >
          {/* Icon Left */}
          <div className="flex-shrink-0 ">
            <img
              src={type === "Premium" ? Premium : type === "Lifetime" ? Lifetime : Standard}
              className={`p-2 w-8 h-8 ${type === "Premium" ? "bg-[#e7ffee]" : type === "Lifetime" ? "bg-[#ffeed7]" : "bg-[#d9e4f4]"} rounded-full`}
              alt={type}
            />
          </div>
          {/* Text Right */}
          <div className="ml-2 flex flex-col items-start ">
            <span className={`text-base sm:text-xl font-semibold ${type === "Premium" ? "text-black" : type === "Lifetime" ? "text-[#d48b00]" : "text-[#6d8bbb]"} `}>
              {type === "Premium" ? "Premium Plans" : type === "Lifetime" ? "Lifetime Plans" : "Standard Plans"}
            </span>
            
            <span className={`text-xs sm:text-sm ${type === "Premium" ? "text-[#3E436D]" : type === "Lifetime" ? "text-[#b08d2e]" : "text-[#a8c0e8]"} mt-1 hidden md:block`}>
              {type === "Premium" ? "Best Value" : type === "Lifetime" ? "One-time payment" : "Basic Packs"}
            </span>
          </div>
        </div>
      );
    })}
  </div>

  {/* Search Bar – Full width on mobile */}
  <div className="w-full mt-4 sm:mt-0 sm:w-96 bg-white rounded-xl flex-shrink-0">
    <div className="relative">
      <input
        type="text"
        placeholder="Search Countries"
        className="w-full rounded-xl bg-white h-10 pl-11 pr-4 text-sm border-2 border-gray-300 focus:ring-2 focus:ring-[#3E436D] transition"
        value={searchQuery}
        onChange={handleSearch}
      />
      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
        <IoMdSearch size={20} className="text-gray-500" />
      </div>
    </div>
  </div>
</div>

</div>

{/* Hover Description Tooltip */}
      {description && (
        <div
          style={{
            position: "absolute",
            top: cursorPosition.y + 10,
            left: cursorPosition.x + 10,
            backgroundColor: "#f1f1f1",
            padding: "8px",
            borderRadius: "6px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
            zIndex: 9999,
            minWidth: "120px",
          }}
          className="text-sm text-gray-700"
        >
          {description}
        </div>
      )}
      {/* Package Type Options */}
      {/* Package Type Options */}
      {selectedPackageType !== "Lifetime" && (

      <div className="flex space-x-8 p-6 mt-5  rounded-lg bg-[#ffffff]">
        {currentPackageOptions.map((type) => (
          <div
            key={type}
            onClick={() => setPackageType(type === "fixed" ? "" : type)}
            onMouseEnter={(e) => handleHover(e, type)}
            onMouseLeave={() => {
              setHovered("");
              setDescription("");
            }}
            className={`cursor-pointer text-lg font-bold ${
              packageType === (type === "fixed" ? "" : type)
                ? "text-[#105255] border-b-4 border-[#3E436D]"
                : "text-[#8ca3cb]"
            }`}
          >
            {type === "fixed"
              ? "Fixed Data"
              : type === "voicedata"
              ? "Voice + Data"
              : type.charAt(0).toUpperCase() + type.slice(1)}
          </div>
        ))}
      </div>
      )}
      {/* Plans Table */}
      {plans.length > 0 && (
        <div className=" p-2 border border-gray-300 shadow-md rounded-lg bg-[#ffffff]">
        <div className="flex flex-row gap-4 mb-4 ">
  {/* Icon + Title */}
  <div className="flex  flex-1"> {/* changed w-full to flex-1 */}
    <img src={Package} alt="package" className="w-8 h-8 mb-1" />
    <span className="ml-3 text-2xl text-black font-bold">Packages</span>
  </div>

  {/* Export Button */}
  <button
    onClick={downloadCSV}
    className="px-4 py-3 text-[#105255] rounded-lg font-bold flex items-center justify-center space-x-2 border border-[#105255] shadow-md hover:bg-[#f0f8f8] transition"
  > {/* removed w-full so button sizes to content */}
    <GoDownload size={24} />
    <span className="text-base">Export</span>
  </button>
</div>



<div className="overflow-x-auto hidden md:block">
  <table className="w-full rounded-lg shadow-lg bg-white">
              <thead className="sticky top-0 bg-gray-200">
                <tr className="border-b">
                  <th className="text-center p-3">Country/Region</th>
                  <th className="text-center p-3">Data</th>
                  <th className="text-center p-3">Validity</th>
                    {/* Conditionally render the "Renewal" header */}
                 {selectedPackageType === "Premium" && packageType === "voicedata" && (
                  <th className="text-center p-3">Voice</th>
                )}

                  <th className="text-center p-3">Plan Code</th>
                  {role === "Partner" && (
                    <>
                      <th className="text-center p-3">Price</th>
                    </>
                  )}
                  {/* Conditionally render the "Renewal" header */}
                  {selectedPackageType === "Premium" && (
                    <th className="text-center p-3">Renewal</th>
                  )}
                  <th className="text-center p-3">Operator</th>
                  <th className="text-center p-3">Add to Cart</th>
                  <th className="text-center p-3">Details</th>
                </tr>
              </thead>
              <tbody>
                {currentPlans.length > 0 ? (
                  currentPlans.map((plan) => (
                    <tr
                    key={plan.planid}
                    className="border-b hover:bg-gray-100 cursor-pointer re"
                    onClick={() => handleBuyClick(plan)} // Opens modal on any row click
                  >
                      <td className="text-center ">
                        <div className="flex justify-start ml-11">
                          {" "}
                          <img
                            src={`https://www.airhubapp.jp/assets/flags/${plan.country}.svg`}
                            alt={`${plan.country} flag`}
                            className="w-8 h-8 mr-2"
                          />
                          <span style={{ lineHeight: "2" }}>
                            {plan.country}
                          </span>
                        </div>
                      </td>
                     <td className="text-center p-1">
  {plan.data || "Unlimited"}
  {plan.plan_datatype ? `/${plan.plan_datatype}` : ""}
</td>

                      <td className="text-center p-1">{plan.validity}</td>
                      {selectedPackageType === "Premium"  && packageType === "voicedata" &&  (
                      <td className="text-center p-1">
                        <div className="flex items-center gap-x-2 relative">
                        {/* Left image (Plus) */}
                        <div className="flex-shrink-0">
                          <img src={Plus} alt="Plus" />
                        </div>

                        {/* Right image (iota) with tooltip */}
                        <div className="relative group flex-shrink-0">
                          <img src={iota} alt="iota" className="cursor-pointer" />
                          <div className="absolute bottom-full  p-2 mb-2 hidden group-hover:block bg-[#3E436D] text-white text-xs z-10 whitespace-nowrap">
                            {plan.remarks}
                          </div>
                        </div>
                      </div>
                      </td>
                    )}
                      <td className="text-center p-1">{plan.plancode}</td>
                      {role === "Partner" && (
                        <>
                          <td className="text-center p-3 px-5">
                            ${plan.sellingcost}
                          </td>
                        </>
                      )}
                    {selectedPackageType === "Premium" && (
                    <td className="text-center p-1">
                      {plan.recharge == 1 ? (
                        <div className="flex justify-center items-center">
                          <img src={Plus} alt="Plus" />
                        </div>
                      ) : plan.recharge == 2 ? (
                        <span>-</span>
                      ) : (
                        "-"
                      )}
                    </td>
                  )}

                      <td className="text-center p-1">{plan.operatorname}</td>
                     <td className="text-center">
  <button
    className="rounded-2xl items-center px-3 py-2 m-1 text-[#3E436D] border-2 focus:outline-none hover:outline-none"
    style={{
      outline: "2px solid #3E436D",
    }}
    onClick={e => {
      e.stopPropagation(); // Prevent row click
      addToCart(plan);
    }}
  >
    Add to cart
  </button>
</td>

                      <td className="text-center">
                        <button
                          className="rounded-lg bg-[#3E436D] items-center p-3 m-1 text-brand-white"
                          onClick={() => handleBuyClick(plan)}
                        >
                          View Details
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center p-4">
                      No Plan for this condition
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
            </div>

{/* Mobile Card View – Only visible below md screens */}
<div className="max-w-sm px-2 py-5 bg-gray-50 md:hidden">
  <div className="flex flex-col gap-4 ">
   {currentPlans.length > 0 ? (
      currentPlans.map((plan) => (
        <div key={plan.planid} className="bg-white shadow-2xl rounded-3xl p-3 flex flex-col relative px-4 py-2 pt-6 pb-6">
          <div className="h-2 w-full rounded-t-3xl bg-gradient-to-r from-[#3E436D] to-[#3edba6] absolute top-0 left-0"></div>
  <div className="flex items-center justify-between p-4">
  {/* Left: Flag + Country */}
  <div className="flex items-center">
    <img
      src={`https://www.airhubapp.jp/assets/flags/${plan.country}.svg`}
      alt=""
      className="w-10 h-10 rounded-full mr-3 shadow"
    />
    <span className="font-bold text-lg text-gray-800">{plan.country}</span>
  </div>
  
  {/* Right: Price */}
  {/* <p className="  rounded-lg bg-[#3E436D] text-2xl px-4 py-2 text-white font-bold shadow-lg">${plan.sellingcost}</p> */}
</div>

          <div className="flex justify-between items-center mt-2 mb-2 border-b pb-2">
            <span className="text-lg text-[#3E436D] font-semibold">{plan.data || "Unlimited"}{plan.plan_datatype ? `/${plan.plan_datatype}` : ""}</span>
            <span className="text-[#3E436D] font-semibold ">{plan.validity}</span>
          </div>
          {/* <div className="flex justify-between pt-2">
            <span className="text-xs text-gray-400">Plan:</span>
            <span className="font-mono">{plan.plancode}</span>
          </div> */}
          <div className="flex justify-between items-center pt-2">
            <span className="text-xs text-gray-400">Operator:</span>
            <span>{plan.operatorname}</span>
          </div>
          <div className="flex justify-between items-center pt-2">
            <span className="text-xs text-gray-400">Renewal:</span>
            <span>{plan.recharge === 1 ? <img src={Plus} alt="Plus" className="inline w-4 h-4 mx-1" /> : "-"}</span>
          </div>
          <div className="flex justify-between mt-4">
            <button className="rounded-2xl px-4 py-2 border-2 text-[#3E436D] border-[#3E436D] hover:bg-[#e6f9f5]" onClick={() => addToCart(plan)}>
              Add to Cart
            </button>
            <button className="rounded-lg bg-[#3E436D] px-4 py-2 text-white font-bold shadow-lg hover:from-[#0e4040]" onClick={() => handleBuyClick(plan)}>
           ${plan.sellingcost}   Buy Now
            </button>
          </div>
        </div>
      ))
    ) : (
      <div className="text-center text-gray-400 py-10">
        No Plan for this condition
      </div>
    )}
  </div>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          </div>
          {/* Modal for buying plan */}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
              content: {
                width: "50%",
                margin: "auto",
                padding: "0px",
                borderRadius: "8px",
                height: "90vh",
              },
            }}
          >
            <div className="absolute top-4 right-5 flex justify-center items-center">
              <button onClick={closeModal} className="text-white">
                <ImCross size={20} />
              </button>
            </div>
            {selectedPlan && (
              <Plan plan={selectedPlan} closeModal={closeModal} />
            )}
          </Modal>
        </div>
      )}
    </>
  );
};

export default EsimStore;
